export type TargetGroupsView = {
  heading: string;
  headingCount: number;
  showGroups: boolean;
  showDivider: boolean;
  showUngroupedHeading: boolean;
  showUngrouped: boolean;
};

export const resolveTargetGroupsView = ({
  groupCount,
  ungroupedTotal,
}: {
  groupCount: number;
  ungroupedTotal: number;
}): TargetGroupsView => {
  const showGroups = groupCount > 0;
  const showUngrouped = ungroupedTotal > 0;

  if (showGroups && showUngrouped) {
    return {
      heading: "Smart Group Collabs",
      headingCount: groupCount,
      showGroups: true,
      showDivider: true,
      showUngroupedHeading: true,
      showUngrouped: true,
    };
  }

  if (showGroups) {
    return {
      heading: "Smart Group Collabs",
      headingCount: groupCount,
      showGroups: true,
      showDivider: false,
      showUngroupedHeading: false,
      showUngrouped: false,
    };
  }

  return {
    heading: showUngrouped ? "All Ungrouped TikTok Collabs" : "Smart Group Collabs",
    headingCount: ungroupedTotal,
    showGroups: false,
    showDivider: false,
    showUngroupedHeading: false,
    showUngrouped,
  };
};
